var React = require('react');

function HeartPurpleIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.5 23L10.6875 21.3455C4.25 15.4921 0 11.6316 0 6.89373C0 3.03324 3.025 0 6.875 0C9.05 0 11.1375 1.01526 12.5 2.61962C13.8625 1.01526 15.95 0 18.125 0C21.975 0 25 3.03324 25 6.89373C25 11.6316 20.75 15.4921 14.3125 21.358L12.5 23Z","fill":"#3D278A"}));
}

HeartPurpleIcon.defaultProps = {"width":"25","height":"23","viewBox":"0 0 25 23","fill":"none"};

module.exports = HeartPurpleIcon;

HeartPurpleIcon.default = HeartPurpleIcon;
